import React from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import WaitDialog from '../../../widgets/WaitDialog';
import EditFatturaInsegnanteWidget from '../../../widgets/EditFatturaInsegnanteWidget';
import getFattureInsegnante from "../../../services/getFattureInsegnante";
import addFattura from "../../../services/addFattura";
import editFattura from "../../../services/editFattura";
import getInsegnantePrices from "../../../services/getInsegnantePrices";
import FixButton from "../../../widgets/Button";
import setInsegnantePrices from "../../../services/setInsegnantePrices";
import getInsegnante from "../../../services/getInsegnante";
import SelectInput from "../../../widgets/SelectInput";
import setRegime from "../../../services/setRegimeInsegnante";

export default class FattureInsegnante extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    this.fatture = [];

    this.fattureOptions = [
      { value: 'FAT_0', label: 'Selezionare…' }, 
      { value: 'FAT_1', label: 'Dipendenti Showrestart' }, 
      { value: 'FAT_2', label: 'Autonomi Regime Forfettario' }, 
      { value: 'FAT_3', label: 'Autonomi Regime Ordinario' }
    ];

    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      selectPdfDatesVisible: false,
      fusioneEnabled: false,
      insegnanti: [],
      gruppiInsegnantiComplete: [],
      mailCompaniesList: [],
      reportPeriod: '',
      waitDialogFileVisible: false,
      editFatturaWidget: false,
      fileReady: false
    }

    this.grid = 2;
    this.tableRef = React.createRef();
    this.editFatturaRef = React.createRef();

    this.pdfElements = [];

    this.insegnanti = [];
    this.gruppiInsegnantiComplete = [];
    this.pageTitle = "Fatture insegnante";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.state = {
      fatturazione: { value: 'FAT_0', label: 'Selezionare…' },
    };

  }


  async reload(){


    this.setState({ isLoading: true });

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentInsegnante = cookies.get('currentInsegnante', { path: '/' });
    
    this.fatture = await getFattureInsegnante(username, token, currentInsegnante);
    this.prezzi = await getInsegnantePrices(username, token, currentInsegnante);
    this.insegnante = await getInsegnante(username, token, currentInsegnante);

    console.log(this.insegnante);

    let lab = {};
    switch (this.insegnante.regime) {
      case 'FAT_1': 
        lab = { value: 'FAT_1', label: 'Dipendenti Showrestart' };
        break;
      case 'FAT_2': 
        lab = { value: 'FAT_2', label: 'Autonomi Regime Forfettario' };
        break;
      case 'FAT_3': 
        lab = { value: 'FAT_3', label: 'Autonomi Regime Ordinario' };
        break;
      default:
        lab = { value: 'FAT_0', label: 'Selezionare…' };
        break;
    }

    this.setState({ fatturazione: lab, isLoading: false });
  }

  async componentDidMount(){
    await this.reload();
  }


  render () {

    if (this.state.isLoading) return <div />;

    return (
      <div id={Math.random()} style={{ paddingBottom: 200 }}>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={this.insegnante ? (this.insegnante.nome + ' ' + this.insegnante.cognome) : 'Fatture insegnante'} button="NUOVO" onClick={() => {
            this.setState({currentFattura: undefined, editFatturaWidget: true})
            var fattura = {};
            this.editFatturaRef.current.refresh(fattura);

          }}/>

          { this.prezzi && (
            <div style={{ backgroundColor: 'white', borderRadius: 10, width: '100%', minHeight: 100, padding: 30, marginBottom: 10 }}>
                <label style={{ color: 'grey', marginTop: 20 }}>Tariffa oraria</label><br/>
                <input type={'number'} step={'0.01'} value={parseFloat(this.prezzi.costo_ora)} placeholder={'Tariffa in €'} style={{ border: '1px solid lightgrey', borderRadius: 10, padding: 10, width: 300 }} onChange={(e) => {
                  
                  this.prezzi.costo_ora = parseFloat(e.target.value);
                  console.log(parseFloat(e.target.value));

                  this.setState({ });
                }} /><br/><br/>
                <label style={{ color: 'grey' }}>Tariffa giornaliera</label><br/>
                <input type={'number'} step={'0.01'} value={parseFloat(this.prezzi.costo_giorno)} placeholder={'Tariffa in €'} style={{ border: '1px solid lightgrey', borderRadius: 10, padding: 10, width: 300 }}  onChange={(e) => {
                  
                  this.prezzi.costo_giorno = parseFloat(e.target.value);
                  console.log(parseFloat(e.target.value));

                  this.setState({ });
                }} /><br/><br/>
            
                <FixButton title={'Salva tariffe'} callback={async () => {

                  const cookies = new Cookies();
                  const username = cookies.get('username', { path: '/' });
                  const token = cookies.get('token', { path: '/' });
                  const currentInsegnante = cookies.get('currentInsegnante', { path: '/' });
                  let res = await setInsegnantePrices(username, token, this.prezzi.costo_ora, this.prezzi.costo_giorno, currentInsegnante);
                  if (res.result === 'KO') {
                    alert('Si è verificato un errore durante l\'aggiornamento dell\'insegnante. Per favore, riprova.');
                    return;
                  }

                  alert('Tariffe aggiornate con successo.');
                }} />
            </div>
          )}

          <div style={{ backgroundColor: 'white', borderRadius: 10, width: '100%', minHeight: 100, padding: 30, marginBottom: 10 }}>
          <div key={Math.random()}>
            <SelectInput 
                ref={this.selectRef}
                value={this.state.fatturazione} 
                name="Regime di fatturazione" 
                hidable={false}
                options={this.fattureOptions} 
                isMulti={false}
                onChange={(option) => 
                    this.setState({fatturazione: option})} 
                />
          </div>
          <br/>
          <FixButton title={'Salva regime'} callback={async () => {

              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });
              
              const currentInsegnante = cookies.get('currentInsegnante', { path: '/' });
              
              let res = await setRegime(username, token, currentInsegnante, this.state.fatturazione.value);
              if (res.result === 'KO') {
                alert('Si è verificato un errore durante l\'aggiornamento del regime dell\'insegnante. Per favore, riprova.');
                return;
              }

              alert('Regime aggiornato con successo.');
              }} />
          <br/>
          </div>
        <div>
        {
          this.fatture.map (fattura => {

            var regime = '';
            switch (fattura.regime) {
              case 'FAT_1': 
                regime = 'Dipendenti Showrestart';
                break;
              case 'FAT_2': 
                regime = 'Autonomi Regime Forfettario';
                break;
              case 'FAT_3': 
                regime = 'Autonomi Regime Ordinario';
                break;
              default:
                regime = 'Non definito';
                break;
            }

            return <div style={{border: '1px solid black', padding: '10px'}} onClick={
              () => {
                this.setState({currentFattura: fattura, editFatturaWidget: true});
                this.editFatturaRef.current.refresh(fattura);
              }
            }>
              <div><b>Data</b>: {fattura.data}</div>
              <div><b>Importo</b>: {fattura.importo}</div>
              <div><b>Regime</b>: {regime}</div>
              <div><b>Stato pagamento</b>: {fattura.flag_pagamento == 1 ? 'PAGATA' : 'NON PAGATA'}</div>
              <div><b>Note</b>: {fattura.note}</div>
            </div>
          })
        }

        </div>

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        <EditFatturaInsegnanteWidget 
            ref={this.editFatturaRef}
            show={this.state.editFatturaWidget}
            fattura={this.state.currentFattura}
            onClose={async fattura => {
              if (fattura == undefined) {
                this.reload();
                this.setState({editFatturaWidget: false});
                return;
              }

              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });
              const currentInsegnante = cookies.get('currentInsegnante', { path: '/' });
          
              if (fattura.id == undefined)
                await addFattura(username, token, currentInsegnante, fattura.data, fattura.importo, fattura.file, fattura.note, fattura.status == 'PAGATA' ? 1 : 0);
              else   
                await editFattura(username, token, fattura.id, currentInsegnante, fattura.data, fattura.importo, fattura.file, fattura.note, fattura.status == 'PAGATA' ? 1 : 0);

              this.setState({editFatturaWidget: false});
              this.reload();
          }}
        />
        </LoadingOverlay>
      </div>
    );
  }
}

